/**
 * @generated SignedSource<<8682c05e5188482433a1259bae3fb8d8>>
 * @relayHash 0a70671b3a280a76523127a1bd3d952e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 48dd906fe95a1ea3bf0dc290612dd880eac0b04cb341b4c314206c96816033b5

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { mainIssueAggQuery } from './mainIssueAggQuery.graphql';

const node: PreloadableConcreteRequest<mainIssueAggQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "48dd906fe95a1ea3bf0dc290612dd880eac0b04cb341b4c314206c96816033b5",
    "metadata": {},
    "name": "mainIssueAggQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
